
import React from 'react';


export const attributes = {"name":"Managing Properties","order":3};
export default function() {
  return (
    <div>
      <h2>MANAGING PROPERTIES</h2>
<p><strong>Edit an existing property</strong>
To edit an existing property or product already in the system, go to <strong>Administration</strong> in the sitemap and click on <strong>Properties</strong>.</p>
<p>Change the view to ensure you can see <strong>All products, families and bundles</strong>:</p>
<p><img src="/AllProductsView1.JPG" alt="All products sample" title="All products sample" /></p>
<p>Then select the product you'd like to edit.</p>
<p>You'll then see a screen that looks like this:</p>
<p><img src="/ManagingProperties1.JPG" alt="Edit property" title="Edit property" /></p>
<p>Depending on the nature of the product, you will see different options for editing the details of the product or property.</p>
<h4>Permissions</h4>
<p>Depending on the role assigned to you in CRM, you may or may not be able to add or edit property details. If you think you should have access to this ability but do not seem to be able to see or edit properties or products, please speak to your manager.</p>

    </div>
  );
};


// WEBPACK FOOTER //
// ../content/pages/properties/managing-properties.md